export default [
  {
    title: '课程学习',
    router: '/course/course-list'
  },
  {
    title: '我的课程',
    router: '/usercenter/mycourse'
  }
]



// WEBPACK FOOTER //
// ./src/page/header/nav.conf.js